import axios from "@/config/http";
import ip from "../config/ip.js";

let base = ip.Ips.ip1;
/*===========枚举=================*/
/**
 * 权益卡类型
 * @returns
 */
export const privilegeCardTypeApi = () => {
  return axios.get(`${base}/biz/enums/privilege/cardType`);
};
/**
 * 权益卡状态
 * @returns
 */
export const privilegeCardStatusApi = () => {
  return axios.get(`${base}/biz/enums/privilege/cardStatus`);
};
/**
 * 权益来源
 * @returns
 */
export const privilegeOriginApi = () => {
  return axios.get(`${base}/biz/enums/privilege/origin`);
};

/*===============================*/
/**
 * 权益池-分页查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegePoolsPage(query) {
  return axios.get(`${base}/biz/privilege/pool/page`, { params: query });
}
/**
 * 权益池-列表查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegePoolsList(query) {
  return axios.get(`${base}/biz/privilege/pool/list`, { params: query });
}
/**
 * 权益池-详情
 *
 * @param {*} id
 * @returns
 */
export function bizPrivilegePoolsInfo(id) {
  return axios.get(`${base}/biz/privilege/pool/info`, { params: { id: id } });
}
/**
 * 权益卡- code是否存在
 *
 * @param {*} code
 * @param {*} id
 * @returns
 */
export function bizPrivilegeCodeExist(code, id) {
  const query = { code: code };
  if (id) {
    query.id = id;
  }
  return axios.get(`${base}/biz/privilege/pool/exist/code`, {
    params: query
  });
}
/**
 * 权益池-保存
 *
 * @param {*} data
 * @returns
 */
export function bizPrivilegePoolsSave(data) {
  return axios.post(`${base}/biz/privilege/pool/save`, data);
}

/**
 * 权益卡-分页查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegeCardPage(query) {
  return axios.get(`${base}/biz/privilege/card/page`, { params: query });
}
/**
 * 权益卡-列表查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegeCardList(query) {
  return axios.get(`${base}/biz/privilege/card/list`, { params: query });
}
/**
 * 权益卡-详情
 *
 * @param {*} id
 * @returns
 */
export function bizPrivilegeCardInfo(id) {
  return axios.get(`${base}/biz/privilege/card/info`, { params: { id: id } });
}

/**
 * 权益卡-保存
 *
 * @param {*} data
 * @returns
 */
export function bizPrivilegeCardSave(data) {
  return axios.post(`${base}/biz/privilege/card/save`, data);
}

/**
 *  发放权益卡
 * @param {*} id
 * @param {array} subscriberIds
 * @returns
 */
export function bizPrivilegeCardGrant(id, subscriberIds) {
  return axios.post(`${base}/biz/privilege/card/grant/${id}`, subscriberIds);
}

/**
 * 权益卡Code-分页查询
 * @param {Object} query
 * @returns
 */
export function bizPrivilegeCardCodePage(query) {
  return axios.get(`${base}/biz/privilege/card/code/page`, { params: query });
}
/**
 * 权益卡Code-生成code
 * @param {*} cardId 权益卡id
 * @param {*} quantity 数量
 * @returns
 */
export function bizPrivilegeCardCodeSave(cardId, quantity) {
  return axios.post(
    `${base}/biz/privilege/card/code/save?cardId=${cardId}&quantity=${quantity}`,
    {}
  );
}

/**
 * 权益折扣-分页查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegeDiscountPage(query) {
  return axios.get(`${base}/biz/privilege/discount/page`, { params: query });
}
/**
 *
 * 权益折扣-列表查询
 * @param {*} query
 * @returns
 */
export function bizPrivilegeDiscountList(query) {
  return axios.get(`${base}/biz/privilege/discount/list`, { params: query });
}

/**
 *
 * 权益折扣-保存
 * @param {*} data
 * @returns
 */
export function bizPrivilegeDiscountSave(data) {
  return axios.post(`${base}/biz/privilege/discount/save`, data);
}
/**
 * 权益折扣-删除
 * @param {*} id
 * @returns
 */
export function bizPrivilegeDiscountDelete(id) {
  return axios.post(`${base}/biz/privilege/discount/delete/?id=${id}`);
}



// WEBPACK FOOTER //
// ./src/api/privilege.js